import React, { useState, useEffect, useRef } from 'react';
import './Footer.css';
import baladoQcIcon from '../assets/balado_qc.png';
import applePodIcon from '../assets/apple_pod.png';
import podbeanIcon from '../assets/podbean-_logo.png';
import cielImage from '../assets/CIEL.jpg';

const Footer = () => {
  const footerRef = useRef(null);
  const [blurAmount, setBlurAmount] = useState(20);
  const [opacity, setOpacity] = useState(0.3);

  // Platform SVG Icon Components
  const YouTubeIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  );

  const FacebookIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );

  const InstagramIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );

  const TikTokIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
    </svg>
  );

  const ApplePodcastsIcon = () => (
    <img src={applePodIcon} alt="Apple Podcasts" style={{ width: '48px', height: '48px', objectFit: 'contain' }} />
  );

  const PodbeanIcon = () => (
    <img src={podbeanIcon} alt="Podbean" style={{ width: '48px', height: '48px', objectFit: 'contain' }} />
  );

  const BaladoQuebecIcon = () => (
    <img src={baladoQcIcon} alt="BaladoQuébec" style={{ width: '48px', height: '48px', objectFit: 'contain' }} />
  );

  const SpotifyIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z"/>
    </svg>
  );


  useEffect(() => {
    const handleScroll = () => {
      if (!footerRef.current) return;

      const rect = footerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Calculate how much of the footer is visible
      const footerTop = rect.top;
      
      // Start revealing when footer is 250px before viewport (during transition space)
      const revealStart = windowHeight + 250;
      // End revealing when footer top reaches viewport
      const revealEnd = windowHeight;
      
      // Calculate progress (0 to 1)
      let progress = 0;
      if (footerTop < revealStart) {
        const distance = revealStart - footerTop;
        const totalDistance = revealStart - revealEnd;
        progress = Math.max(0, Math.min(1, distance / totalDistance));
      }
      
      // Gradually reduce blur from 20px to 0px
      const newBlur = Math.max(0, 20 - (progress * 20));
      // Gradually increase opacity from 0.3 to 1
      const newOpacity = Math.min(1, 0.3 + (progress * 0.7));
      
      setBlurAmount(newBlur);
      setOpacity(newOpacity);
    };

    // Use requestAnimationFrame for smoother performance
    let ticking = false;
    const optimizedScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', optimizedScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    handleScroll(); // Initial call

    return () => {
      window.removeEventListener('scroll', optimizedScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const allPlatforms = [
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@letempsdunemousse',
      icon: <YouTubeIcon />,
      color: '#FF0000',
      isSvg: true
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/letempsdunemousse',
      icon: <FacebookIcon />,
      color: '#1877F2',
      isSvg: true
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/letempsdunemousse',
      icon: <InstagramIcon />,
      color: '#E4405F',
      isSvg: true
    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@letempsdunemousse',
      icon: <TikTokIcon />,
      color: '#000000',
      isSvg: true
    },
    {
      name: 'Apple Podcasts',
      url: 'https://podcasts.apple.com/fr/podcast/le-temps-dune-mousse/id1690225272',
      icon: <ApplePodcastsIcon />,
      color: '#9358B0',
      isSvg: true
    },
    {
      name: 'Podbean',
      url: 'https://www.podbean.com/podcast-detail/sm7kn-2ba707/Le-Temps-d%27Une-Mousse-Podcast',
      icon: <PodbeanIcon />,
      color: '#8E5A9E',
      isSvg: true
    },
    {
      name: 'BaladoQuébec',
      url: 'https://baladoquebec.ca/le-temps-d-une-mousse',
      icon: <BaladoQuebecIcon />,
      color: '#D10000',
      isSvg: true
    },
    {
      name: 'Spotify',
      url: '#',
      icon: <SpotifyIcon />,
      color: '#ba9049',
      isSvg: true
    }
  ];

  return (
    <footer 
      ref={footerRef}
      className="footer" 
      style={{ 
        '--ciel-image': `url(${cielImage})`,
        '--blur-amount': `${blurAmount}px`,
        '--opacity-amount': opacity
      }}
    >
      <div className="footer-background"></div>
      
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section footer-section-full">
              <h3 className="footer-title">OÙ NOUS TROUVER</h3>
              <div className="footer-platforms-grid">
                {allPlatforms.map((platform, index) => (
                  <a
                    key={index}
                    href={platform.url}
                    className="footer-platform-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ '--platform-color': platform.color }}
                  >
                    <span className={`footer-platform-icon ${platform.isSvg ? 'footer-platform-icon-svg' : ''}`}>
                      {platform.icon}
                    </span>
                    <span className="footer-platform-name">{platform.name}</span>
                  </a>
                ))}
              </div>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Contactez-nous</h3>
              <div className="footer-contact">
                <a href="mailto:contact@letempsdunemousse.com" className="footer-contact-link">
                  contact@letempsdunemousse.com
                </a>
                <a href="https://www.patreon.com/letempsdunemousse" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                  Supportez-nous sur Patreon
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Navigation</h3>
              <nav className="footer-nav">
                <a href="#hero" onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }} className="footer-nav-link">Accueil</a>
                <a href="#equipe" onClick={(e) => { e.preventDefault(); scrollToSection('equipe'); }} className="footer-nav-link">L'Équipe</a>
                <a href="#reseaux" onClick={(e) => { e.preventDefault(); scrollToSection('reseaux'); }} className="footer-nav-link">Réseaux</a>
                <a href="#partenaires" onClick={(e) => { e.preventDefault(); scrollToSection('partenaires'); }} className="footer-nav-link">Partenaires</a>
                <a href="#episodes" onClick={(e) => { e.preventDefault(); scrollToSection('episodes'); }} className="footer-nav-link">Épisodes</a>
              </nav>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="footer-copyright">
              © {new Date().getFullYear()} LE TEMPS D'UNE MOUSSE. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

